import { Fragment } from 'react';
import { CheckIcon } from '@heroicons/react/24/outline';

export interface WizardStepDefinition {
    title: string;
}

interface WizardStepIndicatorProps {
    steps: readonly WizardStepDefinition[];
    step: number;
    maxReachable: number;
    onStepClick: (index: number) => void;
}

export function WizardStepIndicator({
    steps,
    step,
    maxReachable,
    onStepClick
}: WizardStepIndicatorProps) {
    return (
        <div className="flex items-center gap-4">
            {steps.map((s, i) => {
                const isCurrent = i === step;
                const isDone = i < step;
                const clickable = i !== step && i <= maxReachable;
                return (
                    <Fragment key={s.title}>
                        {i > 0 && (
                            <div
                                className={`flex-1 h-px ${i <= step ? 'bg-gray-800' : 'bg-gray-200'}`}
                            />
                        )}
                        <button
                            type="button"
                            onClick={() => clickable && onStepClick(i)}
                            className={`flex items-center gap-2.5 ${clickable ? 'cursor-pointer' : 'cursor-default'}`}
                        >
                            <span
                                className={`w-7 h-7 rounded-full flex items-center justify-center text-[12px] font-bold shrink-0 transition-colors ${
                                    isDone || isCurrent
                                        ? 'bg-gray-900 text-white'
                                        : 'border border-gray-300 text-gray-400 bg-white'
                                }`}
                            >
                                {isDone ? <CheckIcon className="h-3.5 w-3.5" /> : i + 1}
                            </span>
                            <span
                                className={`text-[13px] font-semibold whitespace-nowrap ${isCurrent ? 'text-gray-900' : isDone ? 'text-gray-700' : 'text-gray-400'}`}
                            >
                                {s.title}
                            </span>
                        </button>
                    </Fragment>
                );
            })}
        </div>
    );
}
